import { makeStyles } from "@mui/styles";
import { FormikTextField, Section } from "components/disw";
import { FormikErrors } from "formik";
import React from "react";
import SelectComboBox from "../SelectComboBox";
import { ServiceProductCreatable } from "./types";

interface ApiKey {
  id: string;
  name: string;
}

interface GeneralSectionProps {
  values: Partial<ServiceProductCreatable>;
  errors: FormikErrors<ServiceProductCreatable>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate?: boolean
  ) => void;
  apiKeys: ApiKey[];
}

const useStyles = makeStyles(() => ({
  flex: { display: "flex", flexDirection: "column" }
}));

const GeneralSection: React.FC<GeneralSectionProps> = ({
  values,
  errors,
  setFieldValue,
  apiKeys
}) => {
  const classes = useStyles();
  return (
    <Section name="General">
      <FormikTextField
        name="name"
        label="Name"
        placeholder="Enter Name"
        error={Boolean(errors.name)}
        errorMessage={typeof errors.name === "string" ? errors.name : undefined}
        onChange={e => {
          setFieldValue("name", e.target.value);
        }}
      />
      <div className={classes.flex}>
        <SelectComboBox<{ id: string; name: string }>
          label="API Key"
          items={apiKeys}
          valueExpr="id"
          displayExpr="name"
          placeholder="Select API Key"
          onValueChanged={e => {
            if (e.value) setFieldValue("apiKeyId", e.value);
          }}
          value={values.apiKeyId}
          isError={Boolean(errors.apiKeyId)}
          errorText={errors.apiKeyId as string}
        />
      </div>
    </Section>
  );
};

export default GeneralSection;
